import React, { createContext, useEffect } from "react";
import { RecoilRoot } from "recoil";
import { connect, useSelector, useDispatch } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { PersistGate } from "redux-persist/lib/integration/react";
import { persistor } from "./store";
import { fetchUserData } from "./actions/actions_fetchUsers";
import { fetchAllReferenceData } from "./actions/actions_reference";
import NotificationsSystem, { wyboTheme, dismissNotification } from "reapop";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import MainContent from "../../components/MainContent";
import "../css/App.scss";
import "../css/component/Notifications.scss";
import ModalHandler from "../../components/Modal";
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import FullScreenSpinner from "../components/FullScreenSpinner";
import util from "../utils/Helpers";

export const ModalUIContext = createContext({});

function App() {
  const userProfile = useSelector((state) => state.appReducer.userDataReducer.data);
  const dispatch = useDispatch();
  const reCaptchaKey = util.reCaptchaKey();
  const recaptchaToggle = userProfile.Recaptcha;

  const skipToContent = (e) => {
    if (e.key === "Enter") {
      let target = document.getElementById("main-content");
      target.setAttribute("tabindex", "0");
      target.focus();
    }
  };
  useEffect(() => {
    dispatch(fetchUserData());
    dispatch(fetchAllReferenceData());
  }, []);

  // 1. Retrieve the notifications to display.
  const notifications = useSelector((state) => state.notifications);

  const Application = (
    <RecoilRoot>
      <PersistGate loading={<FullScreenSpinner />} persistor={persistor}>
        <BrowserRouter>
          <div className="App">
            <button className="usa-skipnav" onKeyDown={skipToContent}>
              Skip to main content
            </button>
            <ModalHandler />
            <ModalUIContext.Provider>
              <Header user={userProfile ? userProfile.email : "test"} />
              <NotificationsSystem
                theme={wyboTheme}
                notifications={notifications}
                dismissNotification={(id) => dispatch(dismissNotification(id))}
              />
              <ReactNotification />
              <div className="sidebar-nav-container">
                <Sidebar />
              </div>
              <main id="main-content" className="main-content-container">
                <MainContent />
              </main>
            </ModalUIContext.Provider>
          </div>
        </BrowserRouter>
      </PersistGate>
    </RecoilRoot>
  );

  return recaptchaToggle ? (
    <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>
      {Application}
    </GoogleReCaptchaProvider>
  ) : (
    Application
  );
}

export default App;
